module.exports = __webpack_public_path__ + "media/images/teaser-action-map-marker-1-466d7b15f826004a43da72c020a159de.svg";